import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ab5885b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "complete-group" }
const _hoisted_2 = { class: "complete-cell" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", { innerHTML: _ctx.optionHeader }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["complete-cell", { 'error-option': !_ctx.optionValue || 0 === _ctx.optionValue.length,
    'small-letter-spacing': _ctx.smallLatterSpacing }]),
      innerHTML: _ctx.formatOption(_ctx.optionValue)
    }, null, 10, _hoisted_4)
  ]))
}